export default __webpack_public_path__ + "static/media/noise_very_low_light.50b3c781.svg";